





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import FilterIcon from '@/components/SvgIcons/Filter.vue';
@Component({
  components: {
    FilterIcon,
  },
})
export default class PostSearch extends Vue {
  @Prop() selectedCategoryId;
  @Prop() searchText;

  get categories() {
    return vxm.forum.Categories;
  }
  get selectedCategoryText() {
    const selectedCategory = this.categories.find(
      (category) => category.forumCategoryId === this.selectedCategoryId,
    );
    return selectedCategory && selectedCategory.forumCategoryTitle;
  }
}
